import { type FC } from 'react';
import RegisterLayout from '@/registration/component/Register/Layout';
import AddressForm from './AddressForm';
import { useRegistrationQuery } from '@/registration/hook/useRegistrationQuery';
import { useQuery } from '@tanstack/react-query';
import { addressQueryKeyBoth, loadBothAddresses } from '@/api/registration';
import { useTenantApi } from '@/account/hook/useTenantApi';
import QueryContainer from '@/base/QueryContainer/QueryContainer';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';

interface CheckoutProps {
  isUpsell?: boolean
}

const Checkout: FC<CheckoutProps> = ({ isUpsell }) => {
  const { createTenantApiRequest, isLoading: isApiPreparing } = useTenantApi();
  const { eventId } = useRegisterRoute();
  const registrationQuery = useRegistrationQuery(eventId);

  const bothAddressQuery = useQuery(
    [addressQueryKeyBoth],
    async () => { return await fetchBothAddresses(registrationQuery?.data?.id); },
    {
      enabled: !isApiPreparing && !!registrationQuery?.data
    }
  );

  async function fetchBothAddresses(registrationId: number | undefined): Promise<any> {
    if (typeof registrationId === 'undefined') {
      return await Promise.reject(new Error('Invalid registrationId'));
    }

    const response = await loadBothAddresses(createTenantApiRequest)({ registrationId });
    return response.item;
  }

  return (
    <RegisterLayout>
      <QueryContainer query={bothAddressQuery}>
        {(addresses) => { return <AddressForm existingAddresses={addresses} isUpsell={isUpsell} />; }}
      </QueryContainer>
    </RegisterLayout>
  );
};

export default Checkout;
